import styled from 'styled-components'
import { media } from '@/shared/styles'

export const Container = styled.div`
	display: flex;
	margin-bottom: 2rem;
	column-gap: 1rem;
	align-items: baseline;
`

export const SidebarButtonContainer = styled.div`
	display: none;
	${media.md} {
		display: block;
	}
`
